import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import __vue_create_injector__ from 'vue-runtime-helpers/dist/inject-style/browser.mjs';
import magicStyles from './loyalty-card.magic.css.js';
import script from './loyalty-card.js';

const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{class:{card: true, elevation: _vm.elevation, 'no-padding': _vm.noPadding}},[_c('div',{staticClass:"image-wrapper"},[(_vm.icon)?_c('div',{class:{'icon-wrapper': true, 'small-icon': _vm.smallIcon}},[_c('magic-ui-icon',{staticClass:"icon",attrs:{"name":_vm.icon}})],1):_vm._t("image")],2),_vm._v(" "),_c('h1',{class:['title', { 'title--light': _vm.light }]},[(_vm.title)?_c('span',[_vm._v("\n            "+_vm._s(_vm.title)+"\n        ")]):_vm._t("title")],2),_vm._v(" "),_c('div',{staticClass:"description",class:{ 'description--light': _vm.light }},[_vm._t("default")],2)])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-e9565b18_0", { source: magicStyles, map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-e9565b18";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  );

export default __vue_component__;
